export default "__VITE_ASSET__BodJhjdg__"